import SignUpForm from '@/components/organisms/SignUpForm';
import LandingTemplate from '@/components/templates/LandingTemplate';

const SignUpPage = () => {
  return (
    <LandingTemplate>
      <SignUpForm />
    </LandingTemplate>
  );
};

export default SignUpPage;
